const modules = import.meta.glob<string>("./*.glsl", { eager: true, query: "?raw", import: "default" });

export function lightningShaderSource(
  name: "lightning.vert.glsl" | "lightning.frag.glsl" | "picking.vert.glsl" | "picking.frag.glsl",
): string {
  const source = modules[`./${name}`];
  if (source === undefined) {
    throw new Error(`Lightning shader source not found: ${name}`);
  }
  return source;
}
